import React, { useContext } from "react";
import { Link } from "react-router-dom";
import Constants from "../../services/Constants";
// reactstrap components

import * as Service from "../../services/Service.js";
import * as api from "../../actions/api.js";
import { serverLogout } from "../../services/tokenRefresh";
import encryptionService from "../../services/encryptionService";

import swal from "sweetalert";

import { UserContext } from "../../context/user-info-context";
import "assets/css/sw_menu.css";
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Button,
  Container,
  UncontrolledTooltip,
} from "reactstrap";

import { Avatar,ImageList,ImageListItem } 
from "@mui/material";
;

function AfterLoginNavbar(props) {
  const userCtx = useContext(UserContext);

  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [role, setRole] = React.useState(false);
  const [menu, setMenu] = React.useState([]);
  const lan = localStorage.getItem("LangCode"); //userCtx.userInfo.LangId; //"fr_FR";

  const menukey = "menu";

  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );


const itemData = [
 {
    img: require('assets/img/edispLogo.png'),
    title: 'Benin Logo',
  },
  // {
  //   img: require('assets/img/benin.png'),
  //   title: 'Benin Logo2',
  // },
 
  
]; 

  const setMenuTable = () => {
    let auth = encryptionService.decryptUserInfo();
    if (auth) {
      if (menu.length == 0 && auth.length > 0) {
        setMenu(auth[0].menu1);
      }
    } else {
      props.history.push("login");
    }
  };

  function recurciveMenus(menu) {}

  React.useEffect(() => {
    setMenuTable();
    let auth = encryptionService.decryptUserInfo();
    // let auth = Constants.USER_INFO;
    if (auth) {
      var isAdmin = auth[0].role.filter((name) => name.role.includes("Admin"));
      if (isAdmin.length > 0) {
        sessionStorage.setItem("userRole", "Admin");
      } else {
        sessionStorage.setItem("userRole", "User");
      }
    }

    let r = sessionStorage.getItem("userRole");
    setRole(r);
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 50 ||
        document.body.scrollTop > 50
      ) {
        //  setNavbarColor("");
        setNavbarColor("sticky");
      } else if (
        document.documentElement.scrollTop < 51 ||
        document.body.scrollTop < 51
      ) {
        //  setNavbarColor("navbar-transparent");
        setNavbarColor("");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  const onMobileMenuOpen = () => {
    let element = document.getElementById("mobileMenuWrapper");
    element.classList.add("open");
  };
  const onMobileMenuClose = () => {
    let element = document.getElementById("mobileMenuWrapper");
    element.classList.remove("open");
  };


  const handleMenuChange = (url) => {

    localStorage.setItem(
      "FacilityId",
      localStorage.getItem("DefaultFacilityId")
      );

      api.gUserListByFacility({action:"gUserListByFacility", "menukey": '', "FacilityId":localStorage.getItem("DefaultFacilityId")})
      .then((res) => {
        console.log('res.data.datalist: ', res.data.datalist);
       
          localStorage.setItem(
            "UsersListByFacility",
            JSON.stringify(res.data.datalist)
          ); 
          
          /* props.history.push(url); */

        });

      api.gPrescriberListByFacility({action:"gPrescriberListByFacility", "menukey": '', "FacilityId":localStorage.getItem("DefaultFacilityId")})
      .then((res) => {
        console.log('res.data.datalist: ', res.data.datalist);
       
          localStorage.setItem(
            "PrescriberList",
            JSON.stringify(res.data.datalist)
          ); 
          
          /* props.history.push(url); */

        });

        api.gDispenserListByFacility({action:"gDispenserListByFacility", "menukey": '', "FacilityId":localStorage.getItem("DefaultFacilityId")})
        .then((res) => {
          console.log('res.data.datalist: ', res.data.datalist);
         
            localStorage.setItem(
              "DispenserList",
              JSON.stringify(res.data.datalist)
            ); 
            
            props.history.push(url);
  
          });
  

     

  };


     
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}

      {/*============================*/}

      <div id="sticky-header" className={"header-menu " + navbarColor}>
        <div className="container-fluid">
          <div className="row">

            <div className="col-lg-9">
              <div className="tp-mega-full">
                <div className="tp-menu align-self-center">
                  <nav className="desktop_menu">
                    <ul>
                      {menu.map((row, i) => {

                        if(props.location.pathname==row.url)
                        document.title ='eDISP - '+ DispensingLanguage[lan][menukey][row.title]; 

                        if(props.location.pathname=="/my-profile")
                          document.title ='eDISP - '+ DispensingLanguage[lan][menukey]["My Profile"];


                        return (
                          <li key={i}>
                            <a
                              href="#"
                              /* onClick={() => props.history.push(row.url)} */
                              onClick={()=>handleMenuChange(row.url)  }
                            >
                              {DispensingLanguage[lan][menukey][row.title]}

                              {row.submenu.length > 0 ? (
                                <span className="tp-angle pull-right">
                                  <i className="fa fa-angle-down"></i>
                                </span>
                              ) : (
                                <></>
                              )}
                            </a>

                            {row.submenu.length > 0 ? (
                              <ul className={"submenu " + row.position}>
                                {row.submenu.map((row1, i1) => {
                                   if(props.location.pathname==row1.url)
                                   document.title ='eDISP - '+ DispensingLanguage[lan][menukey][row1.title];

                                  return (
                                    <li key={i1}>
                                      <a
                                        href="#"
                                        onClick={()=>handleMenuChange(row1.url)  }
                                       /*  onClick={() =>
                                          props.history.push(row1.url)
                                        } */
                                      >
                                        {
                                          DispensingLanguage[lan][menukey][
                                            row1.title
                                          ]
                                        }

                                        {row1.submenu.length > 0 ? (
                                          <span className="tp-angle pull-right">
                                            <i className="fa fa-angle-right"></i>
                                          </span>
                                        ) : (
                                          <></>
                                        )}
                                      </a>

                                      {row1.submenu.length > 0 ? (
                                        <ul className={"submenu " + row1.position}>
                                          {row1.submenu.map((row2, i2) => {
                                            if(props.location.pathname==row2.url)
                                            document.title ='eDISP - '+ DispensingLanguage[lan][menukey][row2.title];
          
                                            return (
                                              <li key={i2}>
                                                <a
                                                  href="#"
                                                  onClick={() =>handleMenuChange(row2.url) }
                                                  /* onClick={() =>
                                                    props.history.push(row2.url)
                                                  } */
                                                >
                                                  {
                                                    DispensingLanguage[lan][
                                                      menukey
                                                    ][row2.title]
                                                  }
                                                </a>
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      ) : (
                                        <></>
                                      )}
                                    </li>
                                  );
                                })}
                              </ul>
                            ) : (
                              <></>
                            )}
                          </li>
                        );
                      })}

                      <li>
                        <a href="#">{ DispensingLanguage[lan][menukey]['Profile'] }
                          <span className="tp-angle pull-right">
                            <i className="fa fa-angle-down"></i>
                          </span>
                        </a>
                        <ul className="submenu left_position">
                          {/* <li>
                            <a href="#">My account</a>
                          </li>
                          <li>
                            <a href="#">My profile</a>
                          </li>
                          <li>
                            <a href="#">Admin Permissions</a>
                          </li> */}


                          <li>
                              <Link to="/my-profile">{DispensingLanguage[lan][menukey]["My Profile"]}</Link>
                          </li>

                          <li>
                            <a
                              href="#"
                              onClick={async (e) => {
                                document.title ='eDISP - '+ 'Login';
                                e.preventDefault();
                                await serverLogout();
                                sessionStorage.clear();
                                setTimeout(() => {
                                  props.history.push("/login");
                                }, 1000);
                              }}
                            >
                                {DispensingLanguage[lan][menukey]['Logout']}
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="logo">
                <div className="logoFormate">
                    <div className="logo_item">
                      <a href="#">eDISP</a> 
                        <span className="sw_sub_title">
                        {" "}
                        {localStorage.getItem("FacilityName")}
                      </span>
                    </div>

                    <div className="imge_section">
                        <ImageList sx={{ width: 60, height: 60}} cols={1} rowHeight="auto" gap={2}>
                          {itemData.map((item) => (
                            <ImageListItem key={item.img}>
                              <img
                                src={`${item.img}`}
                                alt={item.title}
                                loading="logo"
                              />
                            </ImageListItem>
                          ))}
                        </ImageList>
                    </div> 
                </div>
              </div>
              <button
                onClick={() => onMobileMenuOpen()}
                className="mobile_menu_bars_icon"
                type="button"
              >
                <i className="fas fa-bars"></i>
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* =========Mobile Menu======== */}
      <div id="mobileMenuWrapper" className="mobile-menu-wrapper">
        <div className="off-canvas-overlay">
          <div className="offcanvas-body">
            <div className="mobile_menu_close">
              <button
                onClick={() => onMobileMenuClose()}
                className="mobile_menu_close_icon"
                type="button"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <ul className="sw_mobile_menu">
              {menu.map((row, i) => {
                if(props.location.pathname==row.url)
                document.title ='eDISP - '+ DispensingLanguage[lan][menukey][row.title];

                return (
                  <li key={i}>
                    <a
                      href="#"
                      onClick={() => props.history.push(row.url)}
                    >
                      {DispensingLanguage[lan][menukey][row.title]}

                      {row.submenu.length > 0 ? (
                        <span className="tp-angle">
                          <i className="fa fa-angle-down"></i>
                        </span>
                      ) : (
                        <></>
                      )}
                    </a>

                    {row.submenu.length > 0 ? (
                      <ul className="submenu">
                        {row.submenu.map((row1, i1) => {
                          if(props.location.pathname==row1.url)
                          document.title ='eDISP - '+ DispensingLanguage[lan][menukey][row1.title];

                          return (
                            <li key={i1}>
                              <a
                                href="#"
                                onClick={() => props.history.push(row1.url)}
                              >
                                {DispensingLanguage[lan][menukey][row1.title]}

                                {row1.submenu.length > 0 ? (
                                  <span className="tp-angle">
                                    <i className="fa fa-angle-right"></i>
                                  </span>
                                ) : (
                                  <></>
                                )}
                              </a>

                              {row1.submenu.length > 0 ? (
                                <ul className="submenu">
                                  {row1.submenu.map((row2, i2) => {
                                    if(props.location.pathname==row2.url)
                                    document.title ='eDISP - '+ DispensingLanguage[lan][menukey][row2.title];
  
                                    return (
                                      <li key={i2}>
                                        <a
                                          href="#"
                                          onClick={() =>
                                            props.history.push(row2.url)
                                          }
                                        >
                                          {
                                            DispensingLanguage[lan][menukey][
                                              row2.title
                                            ]
                                          }
                                        </a>
                                      </li>
                                    );
                                  })}
                                </ul>
                              ) : (
                                <></>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <></>
                    )}
                  </li>
                );
              })}

              <li>
                <a href="#">{ DispensingLanguage[lan][menukey]['Profile'] }
                  <span className="tp-angle">
                    <i className="fa fa-angle-down"></i>
                  </span>
                </a>
                <ul className="submenu">
                  <li>
                      <Link to="/my-profile">{DispensingLanguage[lan][menukey]["My Profile"]}</Link>
                  </li>
                  {/*<li>
                    <a href="#">My account</a>
                  </li>
                  <li>
                    <a href="#">My profile</a>
                  </li>
                  <li>
                    <a href="#">Admin Permissions</a>
                  </li>*/}
                  <li>
                    <a
                      href="#"
                      onClick={async (e) => {
                        document.title ='eDISP - '+ DispensingLanguage[lan][menukey]["Logout"];
                        e.preventDefault();
                        await serverLogout();
                        sessionStorage.clear();
                        setTimeout(() => {
                          props.history.push("/login");
                        }, 1000);
                      }}
                    >
                      {DispensingLanguage[lan][menukey]['Logout']}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* =========Mobile Menu======== */}
    </>
  );
}

export default AfterLoginNavbar;
